import { useMediaQuery, useTheme } from '@mui/material';
import { useAppSelector, useIsDesktop } from 'Hooks';

export const BURGER_MENU_EXPANDED_WIDTH_PX = 300;
export const BURGER_MENU_COLLAPSED_WIDTH_PX = 72;

export const useBurgerMenuOffset = (): number => {
  const isDesktop = useIsDesktop();
  const theme = useTheme();
  const isScreenXl = useMediaQuery(theme.breakpoints.up('xl'));
  const isBurgerMenuOpen = useAppSelector(
    (state) => state.menuItems.isBurgerMenuOpen,
  );

  if (!isDesktop) return 0;

  if (isScreenXl || isBurgerMenuOpen) {
    return BURGER_MENU_EXPANDED_WIDTH_PX;
  }

  return BURGER_MENU_COLLAPSED_WIDTH_PX;
};
